import { ArrowRight } from 'lucide-react';
import { PROTBYTE_CONTACT } from '../lib/links';

/** Primary CTA button, styled to match the PROTBYTE site. Opens the
 *  main-site contact page in a new tab. */
export function ContactCta({
  label = 'Talk to PROTBYTE',
  className = ''
}: {
  label?: string;
  className?: string;
}) {
  return (
    <a
      href={PROTBYTE_CONTACT}
      target="_blank"
      rel="noreferrer"
      className={`group inline-flex items-center gap-1.5 rounded-xl bg-linear-to-r from-sentinel-700 to-sentinel-500 px-5 py-2.5 text-sm font-semibold text-white shadow-md transition hover:shadow-lg ${className}`}
    >
      {label}
      <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
    </a>
  );
}
